module.exports = __webpack_public_path__ + "static/media/normal_end.cccea1ca.mp3";